// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"_3NplQJSXokiCsZuZwC9r5A"};